import React, { useEffect } from 'react'

import GenericGrid from '../../../../components/grid/grid'
import { renderColumns } from '../../../../utils/helper'
import CustomCell from '../custom-cell'

const model = [ { name:"Chat Gpt 5.2",id:1 }  , { name:"Clude Opus 4.6",id:2  } , { name:"Gemini 3 pro" , id:3 }  ]

const fieldData = [
    {
        name:"Safety population",
        abbreviation:"SAF",
        id:1
    },
    {
        name:"Baseline Virology Population",
        abbreviation:"BVP",
        id:2
    },
    {
        name:"Virological Failure Population",
        abbreviation:"VFP",
        id:3
    },
    {
        name:"Total Virology Population",
        abbreviation:"TVP",
        id:4
    },
]

const Abbreviation = () => {

   const table = model.map( item => <AbbreviationGrid gridData={item} dataObj = { [...fieldData] } key={item.id}/> )
  return (
    <div style={{display:"flex" , flexDirection:"column"  }}>
         {
           table
         }
    </div>
  )
}

export default Abbreviation

const AbbreviationGrid = (  {gridData , dataObj}  )=>{
         const [dataState, setDataState] = React.useState({
          skip: 0,
          take: 100,
          sort: [],
          filter: null
        });

         const [ data , setData ] = React.useState( [] )

    
        const handleDataStateChange = (e) => {
           setDataState(e.dataState);
        };

           const column = [
            {
               cell:( { dataIndex } ) => <th>{dataIndex + 1}</th>,
               width:"50px"
            },
        {
            title:"Name",
            field:"name",
            cell:CustomCell
        },
        {
            title:gridData.name,
            field:"abbreviation",
            cell:CustomCell
        },
    ]

    useEffect(()=>{
       setData( dataObj )
    },[dataObj])
    return(
        <>
            <GenericGrid
               data={data}
               columns={renderColumns(column)}
               dataState={dataState}
               onDataStateChange={handleDataStateChange}
               pageable={false}
               sortable={false}
               filterable={false}
               style={{ height:"max-content" , width:"100%"  , marginBottom:"40px" }}
               dataItemKey = { "id" }
              selectable={{
                        enabled: false,
                        mode: "single",
                        drag: false,
                        cell: false}}
               onSelectionChange={()=>{}}
               selectedRow = {null}
               storageField = {""}
               />
        </>
    )
}